var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.05264 17.3682C13.8045 17.3682 17.6566 13.516 17.6566 8.76416C17.6566 4.0123 13.8045 0.160156 9.05264 0.160156C4.30078 0.160156 0.448639 4.0123 0.448639 8.76416C0.448639 13.516 4.30078 17.3682 9.05264 17.3682Z",
    fill: "url(#paint0_linear_101_100)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0876 8.30215C13.162 8.3448 13.2238 8.40632 13.2668 8.48051C13.3098 8.55469 13.3324 8.63891 13.3324 8.72465C13.3324 8.81039 13.3098 8.89461 13.2668 8.9688C13.2238 9.04299 13.162 9.10451 13.0876 9.14715L7.74163 12.2012C7.66757 12.2433 7.58374 12.2653 7.49852 12.265C7.41329 12.2646 7.32966 12.2419 7.25597 12.199C7.18228 12.1562 7.12111 12.0948 7.07859 12.021C7.03606 11.9471 7.01367 11.8634 7.01363 11.7782V5.66915C7.01367 5.58393 7.03606 5.5002 7.07859 5.42634C7.12111 5.35249 7.18228 5.29108 7.25597 5.24826C7.32966 5.20545 7.41329 5.18272 7.49852 5.18235C7.58374 5.18198 7.66757 5.20398 7.74163 5.24615L13.0876 8.30215Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_100",
    x1: 9.05264,
    y1: 0.160156,
    x2: 9.05264,
    y2: 17.3682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001A96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#142577"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.285530ccc4bc765096cff497fa360922.svg";
export { ForwardRef as ReactComponent };